import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { GroupOfResearches } from "../../types"
import { initialValuesGroupOfResearch, validationSchemaGroupOfResearch } from "./GroupOfResearchCommon"
import { useDeleteGroupOfResearch, useGroupOfResearch, usePartialUpdateroupOfResearch } from "../../hooks/group-of-researches"
import GroupOfResearchForm from "./GroupOfResearchForm"

export default function GroupOfResearchUpdate() {
  const updateGroupOfResearch = usePartialUpdateroupOfResearch()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: groupOfResearch } = useGroupOfResearch(Number(id))

  const deleteGroupOfResearch = useDeleteGroupOfResearch()

  const [modalStateDeleteGroupOfResearch, modalActionsDeleteGroupOfResearch] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesGroupOfResearch(groupOfResearch), [groupOfResearch])
  const validationSchema = useMemo(() => validationSchemaGroupOfResearch(), [])

  useBreadcrumbs([{ label: "Gruppi di Ricerca", href: "/group-of-researches/group-of-researches" }, { label: "Dettaglio Gruppo di Ricerca" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{groupOfResearch?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteGroupOfResearch.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              if (typeof values.image === "string") {
                delete values.image
              }
              return updateGroupOfResearch.mutateAsync(values as GroupOfResearches).then(() => {
                navigate(`/group-of-researches/group-of-researches`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GroupOfResearchForm />
                </Container>
                <BottomFormFixed url="/group-of-researches/group-of-researches" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteGroupOfResearch.isOpen}
        onClose={modalActionsDeleteGroupOfResearch.close}
        onDelete={() => {
          return deleteGroupOfResearch.mutateAsync(groupOfResearch?.id).then(() => {
            navigate(`/group-of-researches/groups-of-researches`)
          })
        }}
        message="Sei sicuro di voler eliminare il gruppo di ricerca?"
        title="Elimina Gruppo di Ricerca"
      />
    </Layout>
  )
}
